import type { Prototype } from "../prototype-types";

export const bellaLuPrototypes: Prototype[] = [
  {
    id: "bl-starter-prototype",
    name: "Add Legal Name to Setting Page",
    path: "/bl/starter-prototype",
    description: "Business details form with legal business name guidance.",
    owner: "Bella Lu",
    createdAt: "2026-07-15",
    lastUpdated: "2026-07-15",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/0dadb5ec298428e57b8091e7f35fc668cd3fce7b26b950e4f34d6400bbebdabf.png",
    creationTool: "cursor",
  },
  {
    id: "bl-legal-name-checkout",
    name: "OS Retailer Legal Business Name in Checkout",
    path: "/bl/legal-name-checkout",
    description:
      "Checkout flow for opening soon retailers to add and edit a legal business name.",
    owner: "Bella Lu",
    createdAt: "2026-07-15",
    lastUpdated: "2026-07-15",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/6347ff2b23ddf9c1e0f496e4cc9715f668c4348616b2cad6ff5a85c452df11b9.png",
    creationTool: "cursor",
  },
];
